import {BrowserModule} from '@angular/platform-browser';
import {APP_INITIALIZER, Injector, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {PagesModule} from './pages/pages.module';
import {SharedModule} from './shared/shared.module';
import {CoreModule} from './core/core.module';
import {SbHttpInterceptor} from "./core/common/sb-http-interceptor";
import {APP_BASE_HREF} from "@angular/common";
import {ConfirmKnockoutDeactivateGuard} from "./pages/knockout-page/confirm-knockout-deactivate.guard";
import {LoginPageActivateGuard} from "./pages/knockout-page/login-page-activate.guard";
import {FormioModule} from '@formio/angular';
import {HighchartsChartModule} from './highcharts/highcharts-chart.module';
import {MonacoEditorModule} from 'ngx-monaco-editor-v2';;
import {MonacoEditorService} from "./core/services/monaco-editor/monaco-editor.service";
import {ColorPickerModule} from 'ngx-color-picker';
import {featureFlagsInitializerFactory} from "./core/services/feature-flag/feature-flags-initializer-factory";
import {FeatureFlagsInitializer} from "./core/services/feature-flag/feature-flags.initializer";
import {settingsInitializerFactory} from "./core/services/settings/settings.initializer-factory";
import {SettingsInitializer} from "./core/services/settings/settings.initializer";
import {legacyInitializerFactory} from "./core/services/initialization/legacy.initializer-factory";
import {LegacyInitializer} from "./core/services/initialization/legacy.initializer";
import { ScheduleModule } from '@syncfusion/ej2-angular-schedule';
import { TabModule } from '@syncfusion/ej2-angular-navigations';
import { AccordionModule } from '@syncfusion/ej2-angular-navigations';
import { GridModule } from '@syncfusion/ej2-angular-grids';
import { CheckBoxModule } from '@syncfusion/ej2-angular-buttons';
import { ToolbarModule } from '@syncfusion/ej2-angular-navigations';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { ContextMenuModule } from '@syncfusion/ej2-angular-navigations';
import { SwitchModule } from '@syncfusion/ej2-angular-buttons';
import { ButtonModule } from '@syncfusion/ej2-angular-buttons';
import { MultiSelectModule } from '@syncfusion/ej2-angular-dropdowns';
import { TimePickerModule } from '@syncfusion/ej2-angular-calendars';
import { TreeViewModule } from '@syncfusion/ej2-angular-navigations';
import { DialogModule } from '@syncfusion/ej2-angular-popups';
import { ProgressBarModule } from '@syncfusion/ej2-angular-progressbar';
import { GoogleMapsModule } from '@angular/google-maps';
import { PivotViewAllModule } from '@syncfusion/ej2-angular-pivotview';
import { RichTextEditorModule } from '@syncfusion/ej2-angular-richtexteditor';
import {ListViewModule} from "@syncfusion/ej2-angular-lists";
import {MceTocActivateGuard} from "./pages/knockout-page/mce-toc-activate.guard";

@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        HttpClientModule,
        BrowserModule,
        SharedModule,
        CoreModule,
        PagesModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        FormioModule,
        HighchartsChartModule,
        MonacoEditorModule.forRoot(MonacoEditorService.defaultConfig()),
        ColorPickerModule,
        BrowserAnimationsModule,
        ScheduleModule,
        GoogleMapsModule,
        PivotViewAllModule,
        TabModule,
        AccordionModule,
        GridModule,
        CheckBoxModule,
        ToolbarModule,
        DropDownListModule,
        ContextMenuModule,
        SwitchModule,
        ButtonModule,
        MultiSelectModule,
        TimePickerModule,
        TreeViewModule,
        DialogModule,
        ProgressBarModule,
        RichTextEditorModule,
        GoogleMapsModule,
        ListViewModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: SbHttpInterceptor,
            multi: true
        },
        {
            provide: APP_BASE_HREF, useValue: '/'
        },
        {
            provide: APP_INITIALIZER,
            useFactory: featureFlagsInitializerFactory,
            multi: true,
            deps: [FeatureFlagsInitializer]
        },
        {
            provide: APP_INITIALIZER,
            useFactory: settingsInitializerFactory,
            multi: true,
            deps: [SettingsInitializer]
        },
        {
            provide: APP_INITIALIZER,
            useFactory: legacyInitializerFactory,
            multi: true,
            deps: [LegacyInitializer]
        },
        ConfirmKnockoutDeactivateGuard,
        LoginPageActivateGuard,
        MceTocActivateGuard
        // {provide: FormioAppConfig, useValue: ServicelyFormioAppConfig} // commented out as the URLs to use in ServicelyFormioAppConfig are proving difficult to determine.
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private injector: Injector) {
  }
}
